export const MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

/**
 * Observe DOM
 *
 * Uses mutation observer with fallback
 *
 * @type {Function}
 */
export const observeDom = (function () {
    return function (obj, config, callback, log = false) {
        if (!obj || !obj.nodeType === 1) return; // dom element validator

        if (MutationObserver) {
            // define a new observer
            const obs = new MutationObserver(function (mutations, observer) {
                callback(mutations, observer);

                if (log) {
                    let addedNodes = [], removedNodes = [], changedNodes = [];

                    mutations.forEach(record => record.addedNodes.length & addedNodes.push(...record.addedNodes));
                    mutations.forEach(record => record.removedNodes.length & removedNodes.push(...record.removedNodes));
                    mutations.forEach(record => (record.addedNodes.length === 0 && record.removedNodes.length === 0) ? changedNodes.push(record.target) : '');

                    console.log('Added:', addedNodes, 'Removed:', removedNodes, 'Changed:', changedNodes);
                }
            });
            // have the observer observe foo for changes in children
            obs.observe(obj, config);
        } else if (window.addEventListener) {
            obj.addEventListener('DOMNodeInserted', callback);
            obj.addEventListener('DOMNodeRemoved', callback);
        }
    };
})();

/**
 *
 *
 * @param observer
 * @param callback
 */
export const observeDomDisconnect = (observer, callback) => {
    if (MutationObserver) {
        observer.disconnect();
    } else if (window.addEventListener) {
        observer.removeEventListener('DOMNodeInserted', callback);
        observer.removeEventListener('DOMNodeRemoved', callback);
    }
};
